export default __webpack_public_path__ + "static/media/fall.1f5fe867.jpg";